<template>
  <div>
    <el-dropdown
      class="user-action-button"
      v-bind="$attrs"
      @command="handleCommand"
    >
      <span>
        <slot>
          <user-display
            v-if="user && showInfo"
            :user="user"
            @openUserDetail="openUserDetail"
          />
          <el-button
            v-else
            style="color:#ccc ; font-size:1rem;width:100%;border-radius:8px"
            >بدون کاربر</el-button
          >
        </slot>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="showDeviceInPanel">
          <i class="el-icon-link" />
          مشاهده این دستگاه
        </el-dropdown-item>
        <el-dropdown-item
          v-if="canLoginAs"
          command="loginAs"
          class="text-success"
        >
          <i class="el-icon-s-custom " />
          ورود به عنوان این کاربر
        </el-dropdown-item>
        <el-dropdown-item
          v-if="showResetDevice"
          command="resetDevice"
          style="color:#ef394e"
        >
          <i class="el-icon-refresh" />
          ریست‌کردن این دستگاه
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import UserDisplay from '@/components/UserDisplay'
import ResetQuery from '@/graphql/device/ResetDevice.gql'
import { mapGetters } from 'vuex'

export default {
  name: 'UserActionButton',
  components: { UserDisplay },
  props: {
    title: { type: String, default: '' },
    user: { type: Object, default: null },
    userId: { type: [String, Number], default: '' },
    deviceId: { type: [String, Number], default: '' },
    showInfo: { type: Boolean, default: false },
    showEdit: { type: Boolean, default: false },
    showAvatar: { type: Boolean, default: false },
    showView: { type: Boolean, default: true },
    showResetDevice: { type: Boolean, default: false }
  },
  data() {
    return {
      hasDataIcon: false
    }
  },
  computed: {
    id() {
      return Number(this.user ? this.user.id : this.userId)
    },
    hasRole() {
      return !!this.user
    },
    assignRole() {
      return (
        this.$user.can('assignRole') &&
        (!this.isAdmin || this.$user.roleIs(['SUPERADMIN']))
      )
    },
    isAdmin() {
      return this.user.roles.filter(role => role.name === 'admin').length > 0
    },
    canLoginAs() {
      return this.hasRole && this.$user.roleIs(['ADMIN', 'SUPERADMIN'])
    },
    hasDivideSection() {
      return (
        this.showView ||
        this.showEdit ||
        this.showAdviseCmp ||
        this.canLogoutAs ||
        this.canLoginAs
      )
    },
    ...mapGetters({
      emit: 'actionButtonEmit'
    })
  },
  watch: {
    emit(val) {
      if (val) this.$emit('update')
    }
  },
  methods: {
    handleCommand(command) {
      const commit = ['editUser', 'userDetail']
      switch (command) {
        case 'loginAs':
          this.$settings.setCookie(
            'LOGIN_AS',
            `${this.$settings.get('token')}/*/${this.id}`,
            process.env.VUE_APP_DOMAIN
          )
          window.open(process.env.VUE_APP_PANEL, '_blank')
          break
        case 'showDeviceInPanel':
          this.$settings.setCookie(
            'LOGIN_AS',
            `${this.$settings.get('token')}/*/${this.id}`,
            process.env.VUE_APP_DOMAIN
          )
          window.open(
            `${process.env.VUE_APP_PANEL}/device/${this.deviceId}`,
            '_blank'
          )
          break
        case 'resetDevice':
          this.$confirm('آیا از ریست کردن دستگاه اطمینان دارید؟').then(() => {
            this.apollo
              .mutate({
                query: ResetQuery,
                variables: { id: this.deviceId }
              })
              .then(() => {
                this.$message.success('دستگاه مورد نظر با موفقیت ریست شد')
                this.$emit('update')
              })
          })
          break
        default:
          if (commit.includes(command)) {
            this.$store.commit(command, this.id)
          } else {
            this.$emit(command, this.id)
          }
      }
    },
    openUserDetail() {
      if (this.showView) this.$store.commit('userDetail', this.id)
    }
  }
}
</script>
